import { zodResolver } from '@hookform/resolvers/zod';
import { useEffect, useState } from 'react';
import { UseFormReturn, useForm } from 'react-hook-form';
import {
  API,
  AUTH,
  BASE,
  ROUTES,
  URL_RESET_PASSWORD,
  V1,
  apiClient,
} from '@jobcost-monorepo/utils';
import { resetPasswordSchema } from './schema';

export type FormFieldsResetPassword = {
  password: string;
  confirmPassword: string;
};

type Return = {
  methods: UseFormReturn<FormFieldsResetPassword>;
  success: boolean;
  loading: boolean;
  error: string;
  signInLink: string;
  handleResetPassword: (data: FormFieldsResetPassword) => void;
};

type Props = {
  token: string | null;
};

const useResetPassword = ({ token }: Props): Return => {
  const methods = useForm<FormFieldsResetPassword>({
    defaultValues: {
      password: '',
      confirmPassword: '',
    },
    resolver: zodResolver(resetPasswordSchema),
  });

  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>('');
  const [success, setSuccess] = useState<boolean>(false);
  const signInLink = ROUTES.SIGN_IN;

  const handleResetPassword = async ({ password }: FormFieldsResetPassword) => {
    try {
      setLoading(true);
      const response = await apiClient.post({
        url: `${BASE}${API}${V1}${AUTH}${URL_RESET_PASSWORD}`,
        params: { password, token },
      });

      if (response.status === 200 || response.status === 201) {
        setLoading(false);
        setSuccess(true);
        setError('');
        return null;
      }
      setLoading(false);
      setSuccess(false);
      setError('wrongLogin');
    } catch (error) {
      setLoading(false);
      setSuccess(false);
    }

    return null;
  };

  useEffect(() => {
    if (error) {
      setTimeout(() => {
        setError('');
      }, 3000);
    }
  }, [error]);

  return {
    methods,
    success,
    loading,
    error,
    signInLink,
    handleResetPassword,
  };
};
export default useResetPassword;
